module.exports = __webpack_public_path__ + "static/img/anLiBoxImg2.26bc0ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anLiBoxImg2.png
// module id = GjeP
// module chunks = 2